import DomipConfigurationComponent from 'features/systems/domip/components/domip-configuration-component/domip-configuration-component';

const DomipConfiguration = (): React.JSX.Element => {
  return <DomipConfigurationComponent />;
};

export default DomipConfiguration;
